/**
 * Minimal class-name joiner. Kept dependency-free on purpose — the app is already
 * carrying a large bundle, and this is all the primitives need.
 */
export type ClassValue = string | number | null | false | undefined | ClassValue[];

export const cn = (...values: ClassValue[]): string =>
  // Flat() over the recursive ClassValue blows TypeScript's instantiation depth,
  // so the array is widened before flattening and narrowed again at runtime.
  ((values as unknown[]).flat(Infinity) as unknown[])
    .filter((value): value is string | number => typeof value === 'string' || typeof value === 'number')
    .join(' ');
